export class InfoModalConfig {
	type?: EInfoModalType;
	title?: string;
	positiveButton?: string;
	negativeButton?: string;
}

export enum EInfoModalType {
	INFO = 0,
	WARNING = 1,
}
